var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordUpdate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lock_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.174,
    height: 80.174,
    viewBox: "0 0 80.174 80.174",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M0,0H80.174V80.174H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M0,0H80.174V80.174H0Z",
    fill: "none",
    opacity: 0.87
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M50.768,24.384H47.427V17.7a16.7,16.7,0,0,0-33.406,0v6.681H10.681A6.7,6.7,0,0,0,4,31.065V64.471a6.7,6.7,0,0,0,6.681,6.681H50.768a6.7,6.7,0,0,0,6.681-6.681V31.065A6.7,6.7,0,0,0,50.768,24.384ZM20.7,17.7a10.022,10.022,0,0,1,20.043,0v6.681H20.7ZM50.768,64.471H10.681V31.065H50.768ZM30.725,54.449a6.681,6.681,0,1,0-6.681-6.681A6.7,6.7,0,0,0,30.725,54.449Z",
    transform: "translate(9.362 2.341)",
    fill: "#2f68fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordUpdate);
export default __webpack_public_path__ + "static/media/password_update.966824b5adbd5be35654b0700f3dee97.svg";
export { ForwardRef as ReactComponent };